module.exports = __webpack_public_path__ + "static/media/Timonel-min.466f8c5e.png";